import React from 'react';
import Html from 'react-pdf-html';
import { Page, Font, Text, Image, View, Document, StyleSheet } from '@react-pdf/renderer';

const MyStrategy = ({ topic, answeredYesStatementIds, tipSelections, userTips, texts }) => {
    // topic.theme_color
    // switch
    //     case orange
    //         theme_color_light #FEEFE5
    //         theme_color #FAC5A6
    //     case green
    //         theme_color_light #e1eee0
    //         theme_color #C1EDBD

    let themeColorLight;
    let themeColor;

    switch (topic.theme_color) {
        case 'blue':
            themeColorLight = '#e1f6ff';
            themeColor = '#AADEF5';
            break;
        case 'orange':
            themeColorLight = '#FEEFE5';
            themeColor = '#FAC5A6';
            break;
        case 'green':
            themeColorLight = '#e1eee0';
            themeColor = '#C1EDBD';
            break;
        case 'lila':
            themeColorLight = '#eed6ec';
            themeColor = '#EFBCEA';
            break;
        default:
            themeColorLight = '#e1f6ff';
            themeColor = '#AADEF5';
            break;
    }

    if (topic && texts) {
        Font.register({
            family: 'Open Sans',
            fonts: [
                { src: texts.general_site_url + '/wp-content/plugins/pwd-eautismiliitto/assets/OpenSans-Regular.ttf' },
                { src: texts.general_site_url + '/wp-content/plugins/pwd-eautismiliitto/assets/OpenSans-SemiBold.ttf', fontWeight: '600' },
                { src: texts.general_site_url + '/wp-content/plugins/pwd-eautismiliitto/assets/OpenSans-Bold.ttf', fontWeight: 'bold' },
                { src: texts.general_site_url + '/wp-content/plugins/pwd-eautismiliitto/assets/OpenSans-Italic.ttf', fontStyle: 'italic' },
                {
                    src: texts.general_site_url + '/wp-content/plugins/pwd-eautismiliitto/assets/OpenSans-SemiBoldItalic.ttf',
                    fontWeight: '600',
                    fontStyle: 'italic'
                },
                {
                    src: texts.general_site_url + '/wp-content/plugins/pwd-eautismiliitto/assets/OpenSans-BoldItalic.ttf',
                    fontWeight: 'bold',
                    fontStyle: 'italic'
                }
            ]
        });

        Font.register({
            family: 'Work Sans',
            src: texts.general_site_url + '/wp-content/plugins/pwd-eautismiliitto/assets/WorkSans-Black.ttf',
            fontWeight: '900'
        });
        
        Font.register({
            family: 'Work Sans',
            src: texts.general_site_url + '/wp-content/plugins/pwd-eautismiliitto/assets/WorkSans-Bold.ttf',
            fontWeight: '700'
        });

        const styles = StyleSheet.create({
            page: { padding: 30, fontFamily: 'Open Sans' },
            heading1: { fontFamily: 'Work Sans', fontSize: 30, marginBottom: 24, fontWeight: 900, textAlign: 'center' }, // Vinkit, keinot ja konstit
            heading2: { fontFamily: 'Work Sans', fontSize: 14, marginBottom: 20, fontWeight: 700, textAlign: 'center' }, // Vuorovaikutus ja kommunikaatio
            heading3: { fontFamily: 'Work Sans', fontSize: 14, marginBottom: 16, fontWeight: 700 }, // Oma strategia tueksi
            heading4: { fontFamily: 'Work Sans', fontSize: 22, marginBottom: 24, fontWeight: 700, textAlign: 'center' }, // Vapaat sosiaaliset tilanteet ja juhlat ovat minulle hankalia."
            paragraph: { fontSize: 12, marginBottom: 16 },
            worksansbold: { fontFamily: 'Work Sans', fontWeight: 700 },
            tip: { marginBottom: 18, fontSize: 12, backgroundColor: themeColorLight, padding: 20, borderRadius: 20 },
            ownTip: { backgroundColor: themeColor },
            borderBottom: {
                borderBottomWidth: 2,
                borderBottomColor: 'black',
                paddingBottom: 10,
                marginBottom: 10
            },
            borderTop: {
                borderTopWidth: 2,
                borderTopColor: 'black',
                paddingTop: 10,
                marginTop: 10
            },
            header_image: {
                width: 175,
                maxHeight: 175,
                marginBottom: 24,
                marginLeft: 'auto',
                marginRight: 'auto',
                objectFit: 'contain'
            },
            icon_image : {
                width: 24,
                minWidth: 24,
                height: 24,
                minHeight: 24,
                marginBottom: 12,
                marginLeft: 'auto',
                marginRight: 'auto',
                objectFit: 'contain'
            },
            footer_image : {
                width: 200,
                maxHeight: 100,
                marginBottom: 2,
                marginLeft: 'auto',
                marginRight: 'auto',
                objectFit: 'contain'
            }
        });

        const stylesheet = {
            a: {
                color: '#007295',
                fontWeight: '600',
                textDecoration: 'none'
            },
            p: {
                fontSize: 12
            }
          };

        return (
            <Document>
                <Page size="A4" style={styles.page}>
                    {topic.image_url && (
                        <Image style={styles.header_image} src={topic.image_url} />
                    )}

                    <Text style={styles.heading2}>{topic.title}</Text>

                    <Text style={styles.heading1}>{texts.summary_title}</Text>
                    <Text style={styles.paragraph}>{texts.summary_ingress}</Text>
    

                    <View style={[styles.borderTop, styles.borderBottom]}>
                        <Text style={styles.heading3}>{texts.summary_my_strategy_title}</Text>
                        <Text style={styles.paragraph}>{texts.summary_my_strategy_text}</Text>
                    </View>


                    {answeredYesStatementIds.length !== 0 && (
                        answeredYesStatementIds.map((id, index) => {
                            const statement = topic?.statements.find(s => s.ID === id);

                            return (
                                <View key={index} style={styles.borderBottom}>
                                    {/* 1. Väittämä johon vastattu "Kyllä" */}
                                    <Image style={styles.icon_image} src={texts.general_site_url + '/wp-content/plugins/pwd-eautismiliitto/assets/circle-check-' + topic.theme_color + '.png'} />
                                    <Text style={styles.heading4}>"{statement.text}"</Text>

                                    {/* 2. Väittämään liittyvät vinkit */}
                                    {statement.tips && statement.tips.length > 0 && (
                                        statement.tips.map((tip, tipIndex) => (
                                            (() => {
                                                if (tipSelections[statement.ID][tipIndex]) {
                                                    return  <View wrap={false} style={styles.tip} key={tipIndex}>
                                                        <Text style={styles.worksansbold}>Vinkki {tipIndex + 1}</Text>
                                                        <Text>{tip}</Text>
                                                    </View>;
                                                }
                                            })()
                                        ))
                                    )}

                                    {/* 3. Omat vinkit */}
                                    {userTips[statement.ID] && userTips[statement.ID].map((userTip, tipIndex) => (
                                        <View wrap={false} style={[styles.tip, styles.ownTip]} key={tipIndex}>
                                            <Text style={styles.worksansbold}>Oma vinkki {tipIndex + 1}</Text>
                                            <Text>{userTip}</Text>
                                        </View>
                                    ))}
                                </View>
                            );
                        })
                    )}

                    <Image style={styles.footer_image} src={texts.general_footer_logo_url} />
                    <Html stylesheet={stylesheet}>{texts.general_footer_wysiwyg}</Html>
                </Page>
            </Document>
        );
    } else {
        return false;
    }
};

export default MyStrategy;